import "./document-to-pdf.css";
import { parseHtmlDocument } from "./html-document-parser.js";
import { initializeDocumentPdfTool } from "./document-to-pdf-ui.js";

initializeDocumentPdfTool({ mode: "html", parseSource: parseHtmlDocument });
